<script>
import { apiClient, validationService, notificationService } from '@services'
import {
  APP_CONTENT_TURNSTILE_ID,
  APP_DEFAULT_TURNSTILE_ID,
  CONTENT_TURNSTILE_LINK,
  CONTENT_TURNSTILE_LINK_ID,
  GET_PROJECT_BY_ID,
} from '../../../constants/endponts'
import time from '../../../utils/time'

export default {
  props: {
    turnstileData: {
      type: Object,
      default: () => {},
    },
    project: {
      type: Object,
      default: null,
    },
    defaultSettings: {
      type: Boolean,
      default: false,
    },
    showPreviewValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      VUE_APP_API_BASE_URL: process.env.VUE_APP_API_BASE_URL,
      turnstileInfo: this.turnstileData,
      turnstileInfoOriginal: JSON.parse(JSON.stringify(this.turnstileData)),
      title: '',
      url: '',
      currentRoute: null,
      errors: {
        title: '',
        url: '',
      },
      duration: null,
    }
  },
  created() {
    this.currentRoute = this.$route.path
    if (this.turnstileInfo.timestamp) {
      this.duration = this.turnstileInfo.timestamp
    }
  },
  mounted() {
    this.renderDuration()
  },
  methods: {
    saveChanges() {
      let url = APP_CONTENT_TURNSTILE_ID(
        this.project.id,
        this.turnstileInfoOriginal.id
      )

      // updating default turnstile settings
      if (this.defaultSettings) {
        // default settings
        url = APP_DEFAULT_TURNSTILE_ID(
          this.project.id,
          this.turnstileInfoOriginal.id
        )
      }

      this.$emit('loader', true)

      this.turnstileInfo.turnstile_links_id = []
      for (let i in this.turnstileInfo.turnstile_links) {
        this.turnstileInfo.turnstile_links_id.push(
          this.turnstileInfo.turnstile_links[i].id
        )
      }

      apiClient
        .patch(url, this.turnstileInfo)
        .then((res) => {
          notificationService.success('Changes saved')
          this.$emit('loader', false)
          return res
        })
        .catch((err) => {
          this.$emit('loader', false)
          this.$emit('modal-error', 'modalError')
          notificationService.handleResponse(err.response)
          return err
        })
    },

    setTurnstyleOn() {
      this.turnstileInfo.enabled = true
      this.turnstileStatusChange()
    },

    validationHandle(event) {
      this.errorsToState(validationService.validationHandle(event))
    },
    errorsToState(errorValue, callback) {
      let error = errorValue
      const promise = new Promise((resolve) => {
        for (error in this.errors) {
          if (errorValue[error] !== undefined) {
            this.errors[error] = errorValue[error]
          }
        }
        resolve()
      })
      return promise
    },
    addLink(text, url) {
      const data = {
        title: this.title,
        url:
          this.url.includes('http://') || this.url.includes('https://')
            ? this.url
            : 'http://' + this.url,
      }

      const errors = validationService.validateAll(data)
      this.errors = errors

      this.errorsToState(errors).then(() => {
        const result = validationService.validateState(data, this.errors)
        if (result.emptyValues.length > 0 || result.errors.length > 0) {
          return false
        } else {
          apiClient
            .post(CONTENT_TURNSTILE_LINK, {
              app_id: this.project.id,
              title: text,
              url: data.url,
            })
            .then(
              (res) => {
                let arrayLength = this.turnstileInfo.turnstile_links.length

                if (arrayLength < 3 && text !== '' && url !== '') {
                  // this.turnstileInfo.cta_buttons[text]=url
                  this.turnstileInfo.turnstile_links.push(res.data)
                  this.title = ''
                  this.url = ''
                }
              },
              (res) => {
                notificationService.handleResponse(res.response)
              }
            )
        }
      })
    },
    deleteButton(item) {
      const array = this.turnstileInfo.turnstile_links
      let index = -1

      array.forEach((el, location) => {
        if (el.title === item.title && el.url === item.url) {
          index = location
        }
      })

      if (index > -1) {
        apiClient.delete(CONTENT_TURNSTILE_LINK_ID(item.id)).then(
          (res) => {
            array.splice(index, 1)
          },
          (res) => {
            notificationService.handleResponse(res.response)
          }
        )
      }
    },
    openLink(url) {
      window.open(url, '_blank')
    },
    cancelAction() {
      for (let attr in this.turnstileInfoOriginal) {
        if (this.turnstileInfoOriginal[attr] !== this.turnstileInfo[attr]) {
          this.turnstileInfo[attr] = this.turnstileInfoOriginal[attr]
        }
      }
    },
    turnstileStatusChange(e) {
      const url =
        GET_PROJECT_BY_ID(this.project.id) +
        'content_turnstile/' +
        this.turnstileInfoOriginal.id +
        '/channels'
      apiClient
        .patch(url, this.turnstileInfo)
        .then((res) => {
          this.$emit('loader', false)
          // location.reload()
          notificationService.success('Saved!')
          return res
        })
        .catch((err) => {
          // this.$emit('loader', false)
          this.$emit('modal-error', 'modalError')
          return err
        })
      // if (e.target.checked && !this.turnstileInfoOriginal.enabled) {
      //   console.log('here');
      //   // check if default settings is enabled
      //   if (this.project.turnstile.enabled) {
      //     // copy data
      //     console.log(this.project.turnstile.enabled);
      //     for (let attr in this.project.turnstile) {
      //       console.log(this.turnstileInfo[attr]);
      //       this.turnstileInfo[attr] = this.project.turnstile[attr]
      //     }
      //   }
      // }
    },
    showPreview() {
      this.$emit('showPreview')
    },
    renderDuration() {
      let newDuration = ''
      if (this.duration) {
        let currentDuration = ''
        if (
          this.duration === '0' ||
          this.duration === '0:00' ||
          this.duration === '0:0' ||
          this.duration === '00:0' ||
          this.duration === '00:00'
        ) {
          this.duration = '00:03'
        }

        currentDuration = this.duration.replace(':', '')

        const valueToSeconds = this.duration.split(':')
        const seconds = +valueToSeconds[0] * 60 + +valueToSeconds[1]

        newDuration = time.secondsToHms(Number(seconds || currentDuration))
        this.duration = newDuration

        this.parseTimestamp()
      } else {
        this.duration = '00:03'
      }
    },
    parseTimestamp() {
      let p = this.duration.split(':')
      let s = 0
      let m = 1

      while (p.length > 0) {
        s += m * parseInt(p.pop(), 10)
        m *= 60
      }

      this.turnstileInfo.timestamp = s
    },
  },
}
</script>
<template>
  <div class="card">
    <div
      class="card-header bg-white"
      :class="defaultSettings ? 'py-0' : 'py-3'"
    >
      <div
        v-if="!defaultSettings"
        class="d-flex align-items-center justify-content-between"
      >
        <div>
          <span class="text-gray-light"><BaseIcon name="at"/></span>
          <span class="h5">Call to Action</span>
        </div>

        <div class="mr-2">
          <div class="onoffswitch onoffswitch-primary">
            <input
              id="activate"
              ref="onoffswitch"
              v-model="turnstileInfo.enabled"
              type="checkbox"
              name="onoffswitch"
              class="onoffswitch-checkbox"
              @change="turnstileStatusChange"
            />
            <label class="onoffswitch-label m-0" for="activate"></label>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body">
      <form action="">
        <!-- Redirect Button
        <div v-if="!defaultSettings" class="form-group d-flex align-items-top">
          <input
            id="pauseVideo"
            v-model="turnstileInfo.pauseVideo"
            type="radio"
            value="pauseVideo"
            class="mr-3 mt-1"
          />
          <label class="mb-0" for="pauseVideo">
            <small>Pause video</small>
          </label>
        </div>
        -->

        <!-- Redirect Button
        <div v-if="!defaultSettings" class="form-group d-flex align-items-top">
          <input
            id="overlay"
            v-model="turnstileInfo.overlay"
            type="radio"
            value="overlay"
            class="mr-3 mt-1"
          />
          <label class="mb-0" for="overlay">
            <small>Overlay on hover</small>
          </label>
        </div>
        -->

        <!-- time -->
        <div class="form-group d-flex align-items-center">
          <label for="Time" class="w-25">
            <small>Time (sec)</small>
          </label>
          <span class="w-75">
            <BaseInputText
              v-model="duration"
              name="time"
              :placeholder="`00:00`"
              @change="renderDuration"
            />
          </span>
        </div>

        <!-- turnstyle type -->
        <div class="form-group d-flex align-items-center">
          <label for="FormType" class="w-25">
            <small>CTA Type</small>
          </label>
          <span class="w-75">
            <select
              v-model.number="turnstileInfo.turnstile_type"
              type="number"
              class="form-control select-sm"
            >
              <option value="0">Email Capture</option>
              <option value="1">External Links</option>
            </select>
          </span>
        </div>

        <span v-if="turnstileInfo.turnstile_type === 0">
          <!-- title -->
          <div class="form-group d-flex align-items-top">
            <label for="Time" class="w-25">
              <small>Title</small>
            </label>
            <span class="w-75">
              <textarea
                v-model="turnstileInfo.form_title"
                rows="5"
                cols="30"
                class="form-control"
                placeholder=""
              />
            </span>
          </div>

          <!-- subtitle -->
          <div class="form-group d-flex align-items-top">
            <label for="Time" class="w-25">
              <small>Subtitle</small>
            </label>
            <span class="w-75">
              <textarea
                v-model="turnstileInfo.form_subtitle"
                rows="5"
                cols="30"
                class="form-control"
                placeholder=""
              />
            </span>
          </div>

          <!-- Button -->
          <div class="form-group d-flex align-items-center">
            <label for="Time" class="w-25">
              <small>Button</small>
            </label>
            <span class="w-75">
              <BaseInputText
                v-model="turnstileInfo.button_text"
                name="button"
                :placeholder="``"
              />
            </span>
          </div>

          <!-- names -->
          <div class="form-group d-flex align-items-top">
            <label for="names" class="w-25">
              <small>Names</small>
            </label>

            <div class="custom-control custom-checkbox custom-checkbox">
              <input
                id="askNames"
                v-model="turnstileInfo.ask_name"
                type="checkbox"
                class="custom-control-input"
              />
              <label class="custom-control-label" for="askNames">
                <small>Ask for first & last name</small>
              </label>
            </div>
          </div>
        </span>

        <span v-else-if="turnstileInfo.turnstile_type === 1">
          <h4>Add up to 3 links</h4>
          <!-- button text -->
          <div
            class="form-group d-flex align-items-center mt-4"
            :class="
              errors.title || (url.length >= 1 && title.length <= 0)
                ? 'mb-1'
                : 'mb-4 pb-2'
            "
          >
            <label for="Time" class="w-25 mb-0">
              <small>Button</small>
            </label>
            <span class="w-75">
              <BaseInputText
                v-model="title"
                class="mb-0"
                name="title"
                :placeholder="`Button Text`"
                @input="validationHandle"
              />
            </span>
          </div>
          <small
            v-if="errors.title || (url.length >= 1 && title.length <= 0)"
            class="text-danger d-block mb-3 ml-5 pl-4"
          >
            * This field is required
          </small>

          <!-- url -->
          <div
            class="form-group d-flex align-items-center"
            :class="errors.url ? 'mb-1' : 'mb-3 pb-2'"
          >
            <label for="Time" class="w-25 mb-0">
              <small>URL</small>
            </label>
            <span class="w-75">
              <BaseInputText
                v-model="url"
                name="url"
                :placeholder="`URL`"
                class="mb-0"
                @input="validationHandle"
              />
            </span>
          </div>
          <small v-if="errors.url" class="text-danger d-block mb-3 ml-5 pl-4">
            * Please add a valid url
          </small>

          <div
            class="d-flex align-items-center"
            :class="
              turnstileInfo.turnstile_links.length === 3 ? 'mb-1' : 'mb-3'
            "
          >
            <div class="d-flex align-items-center justify-content-end w-100">
              <button
                class="btn btn-primary px-4"
                :disabled="
                  url.length === 0 ||
                    title.length === 0 ||
                    turnstileInfo.turnstile_links.length === 3
                "
                @click.prevent="addLink(title, url)"
                >Add Link</button
              >
            </div>
          </div>
          <small
            v-if="turnstileInfo.turnstile_links.length === 3"
            class="text-gray-light mb-3 d-block text-right"
          >
            * You've already added three links
          </small>

          <!-- Todo: Show the links that have been added here: add links to an array -->

          <span v-if="turnstileInfo.turnstile_links.length" class="pb-5">
            <h4>Links</h4>

            <p v-for="item in turnstileInfo.turnstile_links">
              <a @click.prevent="openLink(item.url)">
                {{ item.title }}
              </a>
              <button
                class="btn btn-outline bg-transparent text-gray-input p-0"
                @click.prevent="deleteButton(item)"
              >
                <BaseIcon name="trash"
              /></button>
            </p>
            <!--
          <ListItem
                v-for="(item, index) in turnstileInfo.cta_buttons"
                :key="index"
                :item-data="item"
                :item-position="index + 2"
              />
        -->
          </span>
        </span>

        <!-- skip -->
        <div class="form-group d-flex align-items-top">
          <label for="Time" class="w-25">
            <small>Skip</small>
          </label>

          <div class="custom-control custom-checkbox custom-checkbox">
            <input
              id="skip"
              v-model="turnstileInfo.allow_skip"
              type="checkbox"
              class="custom-control-input"
            />
            <label class="custom-control-label" for="skip">
              <small>Allow viewers to skip</small>
            </label>
          </div>
        </div>

        <!-- Redirect Button =
        <div class="custom-control custom-checkbox custom-checkbox--radio">
          <input
            id="redirectTraffic"
            v-model="turnstileInfo.redirectTraffic"
            type="checkbox"
            class="custom-control-input"
          />
          <label class="custom-control-label" for="redirectTraffic">
            <small>Redirect Traffic</small>
          </label>
        </div>
        -->

        <!-- Enable Call to Action -->

        <div class="d-flex align-items-center pt-2 mb-1">
          <div class="d-flex align-items-center justify-content-end w-100">
            <button
              v-if="currentRoute.includes('/edit') && !turnstileInfo.enabled"
              class="btn secondary border-secondary mr-2"
              @click.prevent="setTurnstyleOn"
            >
              Enable CTA
            </button>
          </div>
        </div>

        <!-- Show Preview -->

        <div class="d-flex align-items-center pt-2 mb-1">
          <div class="d-flex align-items-center justify-content-end w-100">
            <button
              v-if="currentRoute.includes('/edit')"
              class="btn secondary border-secondary mr-2"
              :disabled="!turnstileInfo.enabled"
              @click.prevent="showPreview"
            >
              {{ showPreviewValue ? 'Hide Preview' : 'Show Preview' }}
            </button>
          </div>
        </div>
        <small
          v-if="currentRoute.includes('/edit') && turnstileInfo.enabled"
          class="text-gray d-block"
          >* In order to preview, please save your edits</small
        >

        <div class="d-flex align-items-center  pt-5">
          <div class="d-flex align-items-center justify-content-end w-100">
            <!--
            <button
              class="btn btn-outline text-gray-input mr-2"
              @click.prevent="cancelAction"
              >Cancel</button
            >
            -->
            <button class="btn btn-primary px-4" @click.prevent="saveChanges"
              >Save</button
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
